const error = "SVGPathCommander Error";
export default error;
